import { Box, Modal } from "@mui/material";
import { FC } from "react"

interface Props {
    childComp: React.ReactNode
    open: boolean
    onClose: () => void
}


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 1
};

export const ModalComponent: FC<Props> = ({ childComp, open, onClose }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
        >
            <Box sx={style}>
                {childComp}
            </Box>
        </Modal>
    )
}